export const rules = {
    end_date: [
        { required: true, message: 'Пожалуйста, введите дата', trigger: 'blur' },
    ],
};
